<div class="m-4 px-6 pb-8 bg-white rounded-lg flex flex-col gap-6">
  <div class="flex flex-col gap-y-7 w-full">
    <div class="lg:px-8 px-0 pb-4 bg-white flex flex-col gap-4">
      <div
        class="px-4 py-2 text-general-title text-white bg-[--brand-azul-primario] flex flex-col gap-4 w-full rounded-lg"
      >
        {{ 'general-pages.confirm-client.client' | translate }}
      </div>
      <div class="grid gap-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3">
        <div class="w-full col-span-full">
          <app-input-general-radio-button
            [formControlGeneral]="newCliente"
            [arrayData]="[
              'general-pages.confirm-client.existingClient' | translate,
              'general-pages.confirm-client.newClient' | translate,
            ]"
          ></app-input-general-radio-button>
        </div>

        <div class="w-full">
          <app-input-general
            [label]="'general-pages.confirm-client.clientName' | translate"
            [placeholder]="'general-pages.confirm-client.clientName' | translate"
            [formControlGeneral]="name"
          ></app-input-general>
        </div>

        @if (this.clienteSTP?.iD_PERSONA != 3) {
          <div class="w-full">
            <app-input-general
              [label]="'general-pages.confirm-client.clientLastName' | translate"
              [placeholder]="'general-pages.confirm-client.clientLastName' | translate"
              [formControlGeneral]="paterno"
            ></app-input-general>
          </div>
          <div class="w-full">
            <app-input-general
              [label]="'general-pages.confirm-client.clientMotherLastName' | translate"
              [placeholder]="'general-pages.confirm-client.clientMotherLastName' | translate"
              [formControlGeneral]="materno"
            ></app-input-general>
          </div>
        }
        <div class="w-full col-span-full">
          <app-input-general
            [label]="'general-pages.confirm-client.rfc' | translate"
            [placeholder]="'general-pages.confirm-client.rfc' | translate"
            [formControlGeneral]="rfc"
          ></app-input-general>
        </div>
      </div>
    </div>

    <div class="lg:px-8 px-0 pb-4 pt-8 flex flex-col gap-4 bg-white">
      <div
        class="px-4 py-2 text-general-subtitle text-white bg-[--brand-azul-primario] w-full rounded-lg"
      >
        {{ 'general-pages.confirm-client.stpSystem' | translate }}
      </div>
      <div
        class="grid justify-center items-center gap-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
      >
        <div class="w-full">
          <app-input-general
            [formControlGeneral]="stp"
            [label]="'general-pages.confirm-client.stpClabe' | translate"
            [placeholder]="'general-pages.confirm-client.stpClabe' | translate"
          ></app-input-general>
        </div>

        <button
          [disabled]="(stp.value || !name.value || !rfc.value) && this.clienteSTP?.haS_ID_CLIENTE"
          (click)="upsertClient()"
          class="button-general text-center !w-auto h-12.75 mt-2"
          matButton="filled"
        >
          {{ 'general-pages.confirm-client.confirmClient' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<app-load-general [load]="loadService"></app-load-general>
